import gql from 'graphql-tag';
import { toastr } from 'react-redux-toastr';
import { closeDeclineReasonModal } from '../../siteadmin/modalActions';


export default function increaseItemStock(orderItemDetails) {
  return async (dispatch, getState, { client }) => {
    try {
      const mutation = gql`
          mutation increaseItemStock($id: Int!, $quantity: Int!) {
            increaseItemStock(id: $id, quantity: $quantity) {
              status
              errorMessage
            }
          }
        `;

      for (const item of orderItemDetails) {
        const { itemId: id, quantity } = item;

        const { data } = await client.mutate({
          mutation,
          variables: {
            id,
            quantity: quantity,
          },
        });

      }

    } catch (error) {
      toastr.error('Error', error.message || 'Something went wrong');
    }
  };
}